<script setup lang="ts">
import Section from '../Section.vue'
import CtaButton from '../CtaButton.vue'
import { TextSectionContent } from './types'
import { Section as SectionInterface, SectionSettings } from '../types'
import { computed } from 'vue'
import UeInlineEditable from '@components/base/UeInlineEditable.vue'

interface Props {
  editable?: boolean
  content: TextSectionContent
  sectionId: string
  settings?: SectionSettings
}

const emit = defineEmits<{
  (e: 'content-change', payload: Partial<SectionInterface>): void
}>()

const props = withDefaults(defineProps<Props>(), {
  settings: (_s) =>
    ({
      alignment: 'center',
      cta: 'Learn more',
      cta_url: '#',
      show_cta: true,
      title: 'Text section',
      design_settings: {
        colors: [],
      },
    }) as SectionSettings,
  content: () =>
    ({
      text: 'This is the main text of the section',
    }) as TextSectionContent,
})
const alignment = computed(() => props.settings.alignment)

const handleHeaderChange = (text: string): void => {
  emit('content-change', {
    id: props.sectionId,
    settings: { ...props.settings, title: text },
    content: props.content,
  })
}

const handleInlineEditableSave = (text: string): void => {
  emit('content-change', {
    id: props.sectionId,
    settings: props.settings,
    content: { text },
  })
}
</script>

<template>
  <Section :settings="settings" :editable="editable" @header-change="handleHeaderChange">
    <div class="text-section">
      <UeInlineEditable
        class="main-text mb-4"
        :editable="true"
        :value="content.text"
        @editable_field:save="handleInlineEditableSave"
      />
      <CtaButton v-if="settings.show_cta" :settings="settings" />
    </div>
  </Section>
</template>

<style scoped lang="sass">
.text-section
  margin-top: 2rem
  text-align: v-bind(alignment)
.main-text
  line-height: 2rem
</style>
